import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import React from "react";
import {
  Users,
  IndianRupeeIcon,
  Star,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";
//import VenueModal from "./venue-modal";
import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogClose,
} from "@/components/ui/dialog";

interface VenueCardProps {
  id: number;
  name: string;
  type: string;
  starrating: number | "Not rated";
  location: string;
  capacity: number;
  rate: number;
  description: string;
  img: string;
  amenities: string[];
  contactphone: string;
  contactemail: string;
}

const renderStars = (rating: number | "Not rated") => {
  if (rating === "Not rated") {
    return <span className="text-sm font-medium text-muted-foreground">Not rated</span>;
  }

  return (
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          className={cn(
            "h-4 w-4",
            i < Math.floor(rating)
              ? "fill-yellow-400 text-yellow-400"
              : "text-gray-300",
          )}
        />
      ))}
      <span className="text-sm font-medium ml-1">{rating}</span>
    </div>
  );
};

export function VenueCard({
  id,
  name,
  location,
  type,
  img,
  starrating,
  capacity,
  rate,
  description,
  amenities,
  contactphone,
  contactemail,
}: VenueCardProps) {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <Card
      key={id}
      className="border rounded-lg p-4 hover:bg-muted/50 transition-colors"
      onClick={handleOpen}
      style={{ cursor: "pointer" }}
    >
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <CardTitle className="text-lg">{name}</CardTitle>
            <p className="text-sm text-foreground">
              {location} • {(type || "").toLowerCase()}
            </p>
          </div>
          {renderStars(starrating)}
        </div>
      </CardHeader>

      <CardContent className="space-y-4">
        <p className="text-sm text-foreground" style={{ color: "grey" }}>
          {description}
        </p>

        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm">
            <Users
              className="h-4 w-4 text-foreground"
              style={{ color: "grey" }}
            />
            <span style={{ color: "grey" }}>Capacity: {capacity} people</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <IndianRupeeIcon
              className="h-4 w-4 text-foreground"
              style={{ color: "grey" }}
            />
            <span style={{ color: "grey" }}>
              Price: Rs. {rate != undefined ? rate.toLocaleString() : "N/A"} per
              day
            </span>
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-sm font-medium" style={{ color: "grey" }}>
            Amenities:
          </p>
          <div className="flex flex-wrap gap-1">
            {/*{amenities.map((amenity) => {
              //const IconComponent = amenityIcons[amenity] || MapPin
              return (
                <Badge
                  key={amenity}
                  variant="outline"
                  className="text-xs gap-1"
                  style={{ color: "grey" }}
                >
                  {amenity}
                </Badge>
              );
            })}*/}
          </div>
        </div>

        <div className="pt-2 border-t space-y-1">
          <div className="flex items-center gap-2 text-sm">
            <Phone
              className="h-4 w-4 text-muted-foreground"
              style={{ color: "grey" }}
            />
            <span style={{ color: "grey" }}>{contactphone}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Mail
              className="h-4 w-4 text-muted-foreground"
              style={{ color: "grey" }}
            />
            <span style={{ color: "grey" }}>{contactemail}</span>
          </div>

          {showModal && (
            <Dialog open={showModal} onOpenChange={handleClose}>
              <DialogContent onClick={(event) => event.stopPropagation()}>
                {/*<DialogTitle>{name}</DialogTitle>*/}

                {img ? (
                  <img
                    src={img}
                    alt={`${name} venue`}
                    className="h-56 w-full rounded-md object-cover"
                  />
                ) : (
                  <div className="flex h-56 w-full items-center justify-center rounded-md bg-muted text-sm text-muted-foreground">
                    No venue image available
                  </div>
                )}

                <DialogTitle>
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <CardTitle className="text-lg">{name}</CardTitle>
                      <p className="text-sm text-foreground">
                        {location} • {(type || "").toLowerCase()}
                      </p>
                    </div>
                    {renderStars(starrating)}
                  </div>
                </DialogTitle>

                <p
                  className="text-sm text-foreground"
                  style={{ color: "grey" }}
                >
                  {description}
                </p>

                {/* Location */}
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-foreground text-slate-400" />
                  <span>{location}</span>
                </div>

                {/* Capacity */}
                <div className="flex items-center gap-2 text-sm">
                  <Users
                    className="h-4 w-4 text-foreground"
                    style={{ color: "grey" }}
                  />
                  <span style={{ color: "grey" }}>
                    Capacity: {capacity} people
                  </span>
                </div>

                {/* Rate */}
                <div className="flex items-center gap-2 text-sm">
                  <IndianRupeeIcon
                    className="h-4 w-4 text-foreground"
                    style={{ color: "grey" }}
                  />
                  <span style={{ color: "grey" }}>
                    Price: Rs.{" "}
                    {rate != undefined ? rate.toLocaleString() : "N/A"} per day
                  </span>
                </div>

                {/* Amenities */}
                <div className="space-y-2">
                  <p className="text-sm font-medium" style={{ color: "grey" }}>
                    Amenities:
                  </p>
                  <div className="flex flex-wrap gap-1">
                    {amenities.map((amenity) => {
                      //const IconComponent = amenityIcons[amenity] || MapPin
                      return (
                        <Badge
                          key={amenity}
                          variant="outline"
                          className="text-xs gap-1"
                          style={{ color: "grey" }}
                        >
                          {amenity}
                        </Badge>
                      );
                    })}
                  </div>
                </div>

                {/* Contact phone */}
                <div className="flex items-center gap-2 text-sm">
                  <Phone
                    className="h-4 w-4 text-muted-foreground"
                    style={{ color: "grey" }}
                  />
                  <a
                    href={`tel:${contactphone}`}
                    onClick={(event) => event.stopPropagation()}
                    className="text-grey-500 underline hover:text-primary"
                  >
                    {contactphone}
                  </a>
                </div>

                {/* Contact email */}
                <div className="flex items-center gap-2 text-sm">
                  <Mail
                    className="h-4 w-4 text-muted-foreground"
                    style={{ color: "grey" }}
                  />
                  <a
                    href={`mailto:${contactemail}`}
                    onClick={(event) => event.stopPropagation()}
                    className="text-grey-500 underline hover:text-primary"
                  >
                    {contactemail}
                  </a>
                </div>

                <DialogClose
                  className="mt-2 inline-flex h-11 w-full items-center justify-center rounded-md border border-primary bg-primary px-4 text-sm font-semibold text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                >
                  Close
                </DialogClose>
              </DialogContent>
            </Dialog>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
